export default __webpack_public_path__ + "static/media/kilauea.f0b372cc.jpg";